import type { TyreLayoutSlot } from '@chukua/common';
import { Table } from 'antd';
import { buildVehicleTyreColumns } from './build-vehicle-tyre-columns';

interface VehicleTyreTableProps {
  slots: TyreLayoutSlot[];
  canManage: boolean;
  selectedCode: string | null;
  onSelect: (code: string) => void;
  onFit: (slot: TyreLayoutSlot) => void;
  onReplace: (slot: TyreLayoutSlot) => void;
  onRotate: (slot: TyreLayoutSlot) => void;
}

/** Every position of the vehicle's layout with the tyre in it, or "Empty"; a position since retired from the layout but still holding a tyre is flagged. */
export function VehicleTyreTable({ slots, canManage, selectedCode, onSelect, onFit, onReplace, onRotate }: VehicleTyreTableProps) {
  const columns = buildVehicleTyreColumns({ canManage, onFit, onReplace, onRotate });

  return (
    <Table
      rowKey="positionCode"
      size="small"
      dataSource={slots}
      columns={columns}
      pagination={false}
      scroll={{ x: 'max-content' }}
      rowClassName={(slot) => (slot.positionCode === selectedCode ? 'bg-primary/10' : '')}
      onRow={(slot) => ({ onClick: () => onSelect(slot.positionCode) })}
    />
  );
}
